import { XF } from "./js/XF";

const { sessionActivity } = document.documentElement.dataset;

if (sessionActivity) {
  XF.ajax(
    "post",
    "/frontier/api/sessionActivity",
    {
      sessionActivity,
    },
    undefined,
    {
      skipDefault: true,
      skipError: true,
      global: false,
    }
  );
}
